import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { homeApi } from '../api/home';
import BottomNav from '../components/BottomNav';
import Navbar from '../components/Navbar';
import './Publish.css';

const Publish = () => {
  const navigate = useNavigate();
  const quillRef = useRef(null);
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    cate_id: '',
    author: '',
    from: '',
    from_url: '',
    images: '',
    video: '',
    audio: '',
    attachment: ''
  });
  const [categoryList, setCategoryList] = useState([]);
  const [currentCategory, setCurrentCategory] = useState(0);
  const [showCategoryPicker, setShowCategoryPicker] = useState(false);
  const [attachmentList, setAttachmentList] = useState({
    images: [],
    video: [],
    audio: [],
    other: []
  });
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const quillModules = useMemo(() => ({
    toolbar: {
      container: [
        [{ 'header': [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'color': [] }, { 'background': [] }],
        ['link', 'image'],
        ['clean']
      ],
      handlers: {
        image: () => {
          const input = document.createElement('input');
          input.setAttribute('type', 'file');
          input.setAttribute('accept', 'image/*');
          input.click();
          input.onchange = async () => {
            const file = input.files[0];
            if (file) {
              try {
                const formData = new FormData();
                formData.append('file', file);
                const result = await homeApi.uploadFile(formData);
                if (result.code === 1) {
                  const quill = quillRef.current.getEditor();
                  const range = quill.getSelection();
                  quill.insertEmbed(range.index, 'image', result.data.fullurl);
                }
              } catch (error) {
                console.error('图片上传失败:', error);
                alert('图片上传失败');
              }
            }
          };
        }
      }
    }
  }), []);

  const quillFormats = useMemo(() => [
    'header', 'bold', 'italic', 'underline', 'strike',
    'list', 'bullet', 'color', 'background', 'link', 'image'
  ], []);

  useEffect(() => {
    checkLoginStatus();
    fetchCategories();
  }, []);

  const checkLoginStatus = () => {
    const token = localStorage.getItem('token');
    setIsLoggedIn(!!token);
    if (!token) {
      navigate('/login');
    }
  };

  const fetchCategories = async () => {
    try {
      const result = await homeApi.getCategoryList();
      if (result.code === 200) {
        setCategoryList(result.data || []);
      }
    } catch (error) {
      console.error('获取分类列表失败:', error);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleCategoryChange = (index) => {
    setCurrentCategory(index);
    if (categoryList[index]) {
      handleInputChange('cate_id', categoryList[index].id);
    }
    setShowCategoryPicker(false);
  };

  const handleFileSelect = (event, type) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    Array.from(files).forEach(file => {
      const fileExt = file.name.split('.').pop().toLowerCase();
      
      let fileType = type;
      if (type === 'other') {
        if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExt)) {
          fileType = 'images';
        } else if (['mp4', 'avi', 'mov'].includes(fileExt)) {
          fileType = 'video';
        } else if (['mp3', 'wav'].includes(fileExt)) {
          fileType = 'audio';
        }
      }
      
      uploadFile(file, fileType);
    });
  };

  const uploadFile = async (file, type) => {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const result = await homeApi.uploadFile(formData);

      if (result.code === 1) {
        setAttachmentList(prev => ({
          ...prev,
          [type]: [...prev[type], {
            name: file.name,
            url: result.data.fullurl
          }]
        }));

        updateAttachmentFields();
        alert('上传成功');
      } else {
        alert(result.msg || '上传失败');
      }
    } catch (error) {
      console.error('上传文件失败:', error);
      alert('上传失败');
    }
  };

  const removeAttachment = (type, index) => {
    setAttachmentList(prev => ({
      ...prev,
      [type]: prev[type].filter((_, i) => i !== index)
    }));
    updateAttachmentFields();
  };

  const updateAttachmentFields = () => {
    setFormData(prev => ({
      ...prev,
      images: attachmentList.images.map(item => item.url).join(','),
      video: attachmentList.video.map(item => item.url).join(','),
      audio: attachmentList.audio.map(item => item.url).join(','),
      attachment: attachmentList.other.map(item => item.url).join(',')
    }));
  };

  const handleSubmit = async () => {
    const token = localStorage.getItem('token');
    console.log('提交时 Token:', token ? token.substring(0, 50) + '...' : 'empty');
    
    if (!formData.title.trim()) {
      alert('请输入标题');
      return;
    }

    if (!formData.content || formData.content.trim() === '') {
      alert('请输入内容');
      return;
    }

    if (!formData.cate_id) {
      alert('请选择分类');
      return;
    }

    try {
      console.log('准备提交，表单数据:', formData);
      const result = await homeApi.publishArticle(formData);
      console.log('提交结果:', result);

      if (result.code === 200) {
        alert('提交成功');
        navigate('/library');
      } else {
        alert(result.msg || '提交失败');
      }
    } catch (error) {
      console.error('提交失败:', error);
      console.error('错误详情:', error.response);
      alert('提交失败: ' + (error.message || '未知错误'));
    }
  };

  const goBack = () => {
    navigate(-1);
  };

  const currentCategoryName = categoryList.length > 0 && categoryList[currentCategory]
    ? categoryList[currentCategory].name
    : '请选择分类';

  return (
    <div className="publish-page">
      <Navbar title="发布资料" />

      <div className="publish-container">
        <div className="form-section">
          <div className="form-item">
            {/* <label className="form-label">标题</label> */}
            <input
              type="text"
              value={formData.title}
              onChange={(e) => handleInputChange('title', e.target.value)}
              placeholder="请输入资料标题"
              className="form-input"
            />
          </div>

          <div className="form-item">
            {/* <label className="form-label">作者</label> */}
            <input
              type="text"
              value={formData.author}
              onChange={(e) => handleInputChange('author', e.target.value)}
              placeholder="请输入作者"
              className="form-input"
            />
          </div>

          <div className="form-item">
            {/* <label className="form-label">来源</label> */}
            <input
              type="text"
              value={formData.from}
              onChange={(e) => handleInputChange('from', e.target.value)}
              placeholder="请输入来源"
              className="form-input"
            />
          </div>

          <div className="form-item">
            {/* <label className="form-label">来源网址</label> */}
            <input
              type="text"
              value={formData.from_url}
              onChange={(e) => handleInputChange('from_url', e.target.value)}
              placeholder="请输入来源网址（可选）"
              className="form-input"
            />
          </div>

          <div className="form-item" onClick={() => setShowCategoryPicker(true)}>
            {/* <label className="form-label">分类</label> */}
            <div className="category-selector">
              <span>{currentCategoryName}</span>
              <span className="arrow">→</span>
            </div>
          </div>

          <div className="form-item">
            {/* <label className="form-label">附件上传</label> */}
            <div className="attachment-note">支持格式：PDF、JPG、PNG、WORD、MP3、MP4</div>
            
            {attachmentList.images.length > 0 && (
              <div className="attachment-section">
                <div className="attachment-type-label">图片</div>
                {attachmentList.images.map((item, index) => (
                  <div key={`images-${index}`} className="attachment-item">
                    <span className="attachment-name">{item.name}</span>
                    <span className="remove-btn" onClick={() => removeAttachment('images', index)}>✕</span>
                  </div>
                ))}
              </div>
            )}

            {attachmentList.video.length > 0 && (
              <div className="attachment-section">
                <div className="attachment-type-label">视频</div>
                {attachmentList.video.map((item, index) => (
                  <div key={`video-${index}`} className="attachment-item">
                    <span className="attachment-name">{item.name}</span>
                    <span className="remove-btn" onClick={() => removeAttachment('video', index)}>✕</span>
                  </div>
                ))}
              </div>
            )}

            {attachmentList.audio.length > 0 && (
              <div className="attachment-section">
                <div className="attachment-type-label">音频</div>
                {attachmentList.audio.map((item, index) => (
                  <div key={`audio-${index}`} className="attachment-item">
                    <span className="attachment-name">{item.name}</span>
                    <span className="remove-btn" onClick={() => removeAttachment('audio', index)}>✕</span>
                  </div>
                ))}
              </div>
            )}

            {attachmentList.other.length > 0 && (
              <div className="attachment-section">
                <div className="attachment-type-label">其他</div>
                {attachmentList.other.map((item, index) => (
                  <div key={`other-${index}`} className="attachment-item">
                    <span className="attachment-name">{item.name}</span>
                    <span className="remove-btn" onClick={() => removeAttachment('other', index)}>✕</span>
                  </div>
                ))}
              </div>
            )}

            {attachmentList.images.length === 0 &&
             attachmentList.video.length === 0 &&
             attachmentList.audio.length === 0 &&
             attachmentList.other.length === 0 && (
              <div className="attachment-empty">暂无附件</div>
            )}

            <div className="upload-btn" onClick={() => document.getElementById('file-input').click()}>
              <span>➕</span>
              <span>添加附件</span>
            </div>
            <input
              id="file-input"
              type="file"
              multiple
              accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.mp3,.mp4"
              style={{ display: 'none' }}
              onChange={(e) => handleFileSelect(e, 'other')}
            />
          </div>

          <div className="form-item">
            <label className="form-label">内容</label>
            <div className="editor-container">
              <ReactQuill
                ref={quillRef}
                value={formData.content}
                onChange={(value) => handleInputChange('content', value)}
                modules={quillModules}
                formats={quillFormats}
                theme="snow"
                placeholder="请输入资料内容..."
              />
            </div>
          </div>

          <button className="submit-btn" onClick={handleSubmit}>
            提交审核
          </button>
        </div>
      </div>

      {showCategoryPicker && (
        <div className="picker-overlay" onClick={() => setShowCategoryPicker(false)}>
          <div className="picker-content" onClick={(e) => e.stopPropagation()}>
            <div className="picker-header">
              <span onClick={() => setShowCategoryPicker(false)}>取消</span>
              <span>选择分类</span>
              <span onClick={() => setShowCategoryPicker(false)}>确定</span>
            </div>
            <div className="picker-list">
              {categoryList.map((item, index) => (
                <div
                  key={item.id}
                  className={`picker-item ${currentCategory === index ? 'active' : ''}`}
                  onClick={() => handleCategoryChange(index)}
                >
                  {item.name}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      <BottomNav activeTab="publish" />
    </div>
  );
};

export default Publish;
